import React, { useCallback, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { getOrganizationUserList } from "../../../api/organization/organizationUser";
import { getVesselUserList } from "../../../api/vessel/vesselUser";
import { Button } from "../../button/Button";
import Col from "../../grid/Col";
import Row from "../../grid/Row";
import { ItemListForUser } from "../../../reusable/ItemList/ItemListForUser";
import { UserSelect } from "../UserSelect";

const msgKey = "userMultiSelect";

export const UserMultiSelect = ({ vesselId, orgId, selectedList = [], onChange, placeholder }) => {
    const [userList, setUserList] = useState(null);

    const fetchUsers = useCallback(() => {
        if (vesselId) {
            getVesselUserList(vesselId).then(setUserList);
        } else if (orgId) {
            getOrganizationUserList(orgId).then(setUserList);
        }
    }, [vesselId, orgId]);

    useEffect(fetchUsers, [fetchUsers]);

    return (
        <Row>
            <Col span={24}>
                <UserSelect
                    busy={!userList}
                    userList={userList?.filter((user) => !selectedList.some((selected) => selected.id === user.id))}
                    onChange={(userId) => {
                        const user = userList?.find((u) => u.id === userId);
                        if (user) {
                            onChange([...selectedList, user]);
                        }
                    }}
                    placeholder={placeholder || <FormattedMessage id={`${msgKey}.selectUsers`} />}
                />
            </Col>
            {selectedList.length > 0 ? (
                <Col span={24}>
                    <ItemListForUser
                        list={selectedList}
                        append={(user) => (
                            <Button
                                square
                                size="small"
                                icon="close"
                                color="silent"
                                onClick={() => onChange(selectedList.filter((u) => u.id !== user.id))}
                            />
                        )}
                    />
                </Col>
            ) : null}
        </Row>
    );
};
